<script lang="ts">
  import type { CommentType, UserType } from './types';
  import CommentItem from './CommentItem.svelte';

  type Props = {
    comments: CommentType[];
    currentUser: UserType | null;
    commentable: { type: string; id: string | number };
    onVote: (comment: CommentType) => void;
    replyingTo: number | null;
    onReplyClick: (commentId: number) => void;
    onReplyCancel: () => void;
    onReplySubmitted: (comment: CommentType) => void;
    onDelete: (commentId: number) => void;
    onError: (error: Error) => void;
    loading: boolean;
    hasMore: boolean;
    onLoadMore: () => void;
  };

  let {
    comments,
    currentUser,
    commentable,
    onVote,
    replyingTo,
    onReplyClick,
    onReplyCancel,
    onReplySubmitted,
    onDelete,
    onError,
    loading,
    hasMore,
    onLoadMore,
  }: Props = $props();

  // Only show root comments in the main list (Instagram-style)
  const rootComments = $derived(() => {
    return comments.filter((comment) => comment.parent_id === null);
  });
</script>

<div class="comments-list">
  {#if loading && rootComments().length === 0}
    <div class="loading">Carregando comentários...</div>
  {:else if rootComments().length === 0}
    <div class="no-comments">Nenhum comentário ainda. Seja o primeiro!</div>
  {:else}
    {#each rootComments() as comment (comment.id)}
      <CommentItem
        {comment}
        {currentUser}
        {commentable}
        {onVote}
        {replyingTo}
        {onReplyClick}
        {onReplyCancel}
        {onReplySubmitted}
        {onDelete}
        {onError}
        {loading}
      />
    {/each}

    {#if hasMore}
      <div class="load-more">
        <button onclick={onLoadMore} disabled={loading}>
          {loading ? 'Carregando...' : 'Carregar mais comentários'}
        </button>
      </div>
    {/if}
  {/if}
</div>

<style>
  .comments-list {
    margin-top: 16px;
  }
  .loading,
  .no-comments {
    text-align: center;
    padding: 20px;
    color: #666;
  }
  .load-more {
    text-align: center;
    padding: 16px 0;
  }
  .load-more button {
    background-color: transparent;
    border: 1px solid #d1d5da;
    border-radius: 20px;
    color: #24292e;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    cursor: pointer;

    :global(.dark) :global(#chapter-section) & {
      background-color: #2d333b;
      border-color: #444d56;
      color: #f6f8fa;
    }
  }
  .load-more button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
</style>
